import { format } from 'date-fns';
import { EmployeeComplianceData, SummaryDay, SummaryEmployee } from './summary.types';

export interface complianceAttendanceSummary {
  date: string;
  hasHomeAttendance?: boolean;
  remoteAttendance?: {
    locationId: number;
  }[];
}

export const buildComplianceDataForEmployee = (schedule: SummaryDay[], homeLocationId: number) => {
  const complianceData: EmployeeComplianceData = {
    holidays: 0,
    attendanceSummary: [],
    shifts: 0,
    avaliableDays: 0,
    actualTime: 0,
    basicTime: 0
  };

  schedule.forEach(day => {
    if (day.shifts.length === 0) {
      complianceData.holidays += 1;

      if (!day.leaveType) {
        complianceData.avaliableDays += 1;
      }
    } else {
      const attendanceSummaryForDay: complianceAttendanceSummary = {
        date: format(new Date(day.date), 'yyyy/MM/dd'),
        remoteAttendance: []
      };

      day.shifts.forEach(shift => {
        const shiftLocationId = Number(shift.locationId);

        if (shiftLocationId === homeLocationId) {
          attendanceSummaryForDay.hasHomeAttendance = true;
        } else {
          attendanceSummaryForDay.remoteAttendance?.push({
            locationId: shiftLocationId
          });
        }

        complianceData.basicTime += shift.basicTime;
        complianceData.actualTime += shift.actualTime;
        complianceData.shifts += 1;
      });

      const uniqueRemoteAttendanceEntries = Array.from(
        new Map(attendanceSummaryForDay.remoteAttendance?.map(item => [item.locationId, item])).values()
      );
      attendanceSummaryForDay.remoteAttendance = uniqueRemoteAttendanceEntries;

      complianceData.attendanceSummary.push(attendanceSummaryForDay);
    }
  });

  return complianceData;
};

export interface ComplianceTotals {
  attendanceDays: number;
  holidayDays: number;
  actualTime: number;
}

export const buildComplianceDataTotals = (schedules: SummaryEmployee[]): ComplianceTotals => {
  let totalAttendanceDays = 0;
  let totalHolidayDays = 0;
  let totalTime = 0;

  schedules.forEach(schedule => {
    if (schedule.homeEmployee) {
      totalAttendanceDays += schedule.compliance.attendanceSummary.length;
      totalHolidayDays += schedule.compliance.holidays;
      totalTime += schedule.compliance.actualTime;
    }
  });

  return { attendanceDays: totalAttendanceDays, holidayDays: totalHolidayDays, actualTime: totalTime };
};
